import { render, staticRenderFns } from "./ReasonsSelect.vue?vue&type=template&id=1db3446b&scoped=true"
import script from "./ReasonsSelect.vue?vue&type=script&lang=js"
export * from "./ReasonsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3446b",
  null
  
)

export default component.exports